// react
import { Cell } from "fixed-data-table-2";
import { List, Map } from "immutable";
// dependencies
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

import Checkbox from "../../../../components/Inputs/Checkbox";
// components
import Link from "../../../../components/Link";
import Spinner from "../../../../components/Spinner";

// utils
import EmployeeURL from "../../../../utils/URLs/Employee";
import EmployeeAvatar from "../../../../utils/URLs/EmployeeAvatar";

export default class ProxyCell extends React.PureComponent {
	static propTypes = {
		onCheckboxChange: PropTypes.func,
		rowIndex: PropTypes.number,
		columnKey: PropTypes.string,
		departments: PropTypes.instanceOf(Map),
		width: PropTypes.number.isRequired,
		type: PropTypes.string.isRequired,
		userMap: PropTypes.instanceOf(Map).isRequired,
		userSelectionMap: PropTypes.instanceOf(Map).isRequired,
		fieldData: PropTypes.instanceOf(Map).isRequired,
		data: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {
		rowIndex: -1,
		columnKey: null,
		departments: Map(),
		onCheckboxChange: () => {},
	};

	constructor(props) {
		super(props);

		this.cellElement = React.createRef();
	}

	state = {
		showTitle: false,
	};

	handleCheckboxClick = (nextValue) => {
		const { data, rowIndex } = this.props;
		const userId = data.get(rowIndex);

		this.props.onCheckboxChange(userId, nextValue);
	};

	handleMouseEnter = () => {
		try {
			const cellWidth = this.props.width;
			const contentWidth = this.cellElement.current.getBoundingClientRect().width;

			if (cellWidth < contentWidth) {
				this.setState({ showTitle: true });
			}
		} catch (ermahgerd) {
			//
		}
	};

	handleMouseLeave = () => {
		this.setState({ showTitle: false });
	};

	render() {
		// destructure
		const { showTitle } = this.state;
		const {
			columnKey,
			data,
			rowIndex,
			userMap,
			departments,
			type,
			onCheckboxChange,
			userSelectionMap,
			fieldData,
			...otherProps
		} = this.props;

		// set var out of switch scope
		let displayLabel = "";
		const userId = data.get(rowIndex);

		switch (type) {
			case "_displayName": {
				const avatarSize = 20;
				const userName = userMap.getIn([userId, "name"], "");

				const style = {
					left: 8,
					top: 5,
					height: avatarSize,
					width: avatarSize,
				};

				displayLabel = [
					<img
						key="avatar"
						alt={userName}
						className="person-avatar"
						style={style}
						src={EmployeeAvatar(userId)}
					/>,
					<Link
						forceHardReload={true}
						key="name"
						style={{ marginLeft: avatarSize + 5 }}
						href={EmployeeURL(userId)}
						testId={`link-${userName.replace(" ", "-")}`}
					>
						{userName}
					</Link>,
				];

				break;
			}

			case "_checkBox": {
				const isChecked = userSelectionMap.get(userId, false);
				const isSpinner = isChecked.slice && isChecked.slice(0, 8) === "spinning";

				displayLabel = (
					<div style={{ textAlign: "center" }} data-testid={`checkbox-${userId}`}>
						{isSpinner ? (
							<Spinner size={20} />
						) : (
							<Checkbox
								size={16}
								value={isChecked}
								onChange={() => this.handleCheckboxClick(!isChecked)}
							/>
						)}
					</div>
				);

				break;
			}

			case "person": {
				const avatarSize = 20;
				const personId = userMap.getIn([userId, "dataFields", columnKey, "value"], "");
				const personName = userMap.getIn([personId, "name"], "");

				if (personId && personName) {
					displayLabel = [
						<img
							key="avatar"
							alt={personName}
							className="person-avatar"
							style={{
								left: 8,
								top: 5,
								height: avatarSize,
								width: avatarSize,
							}}
							src={EmployeeAvatar(personId)}
						/>,
						<Link
							forceHardReload={true}
							key="name"
							style={{ marginLeft: avatarSize + 5 }}
							href={EmployeeURL(personId)}
							testId={`link-${personName.replace(" ", "-")}`}
						>
							{personName}
						</Link>,
					];
				} else {
					displayLabel = "";
				}

				break;
			}
			case "people": {
				const listOfPeopleIds = userMap.getIn([userId, "dataFields", columnKey, "value"], []) || [];
				const listOfUsersToDisplay = [];
				listOfPeopleIds.forEach((personId, idx) => {
					const personName = userMap.getIn([personId, "name"], "");
					if (personId && personName) {
						listOfUsersToDisplay.push(
							<a key={`name_${idx}`} style={{ marginLeft: 2 }} href={EmployeeURL(personId)}>
								{personName}
								{idx + 1 === listOfPeopleIds.size ? "" : ","}
							</a>
						);
					}
				});
				displayLabel = listOfUsersToDisplay;

				break;
			}

			case "department": {
				const departmentId = userMap.getIn([userId, "dataFields", columnKey, "value"], "");
				displayLabel = <div className="cell-value">{departments.getIn([departmentId, "name"])}</div>;

				break;
			}

			case "date": {
				const value = userMap.getIn([userId, "dataFields", columnKey, "value"], "");
				const dateMoment = moment(value);

				if (dateMoment.isValid()) {
					displayLabel = <div className="cell-value">{dateMoment.format("MMMM D, YYYY")}</div>;
				} else {
					displayLabel = <div className="cell-value">{value}</div>;
				}

				break;
			}

			// these are dates where we want to not even consider the timezone.
			// using moment.js' utc function will effectively drop the time
			// component.
			case "dumb-date": {
				const value = userMap.getIn([userId, "dataFields", columnKey, "value"], "");
				const dateMoment = moment.utc(value);

				if (dateMoment.isValid()) {
					displayLabel = <div className="cell-value">{dateMoment.format("MMMM D, YYYY")}</div>;
				} else {
					displayLabel = <div className="cell-value">{value}</div>;
				}

				break;
			}

			case "custom": {
				const cell = fieldData.get("cell");
				const user = userMap.getIn([userId], Map());
				displayLabel = cell({ userId, user });
				break;
			}

			case "custom.old": {
				const cell = fieldData.get("cell");
				const cellProps = { ...cell.props };

				if (cell.props.onClick) {
					const handleClick = () => {
						const cellData = {
							userId,
							user: userMap.getIn([userId], Map()),
						};
						cell.props.onClick(cellData);
					};

					cellProps.onClick = handleClick;
				}

				displayLabel = <div className="cell-value">{React.createElement(cell.type, cellProps)}</div>;
				break;
			}

			case "list":
			case "multi-select": {
				let value = "";

				try {
					value = (userMap.getIn([userId, "dataFields", columnKey, "value"], []) || []).join(", ");
				} catch (err) {
					value = "";
				}

				displayLabel = value;
				break;
			}

			default: {
				if (showTitle) {
					// otherProps.tooltime = 100;
					otherProps.position = "left";
					otherProps.title = userMap.getIn([userId, "dataFields", columnKey, "value"], "");
				}

				displayLabel = userMap.getIn([userId, "dataFields", columnKey, "value"], "");
				break;
			}
		}

		return (
			<Cell
				onMouseEnter={this.handleMouseEnter}
				onMouseLeave={this.handleMouseLeave}
				className="body-cell"
				data-testid={`cell-${columnKey}`}
				{...otherProps}
			>
				<div style={{ position: "static" }} ref={this.cellElement}>
					{displayLabel}
				</div>
			</Cell>
		);
	}
}
